import { createStore, createEffect } from "effector";
import { getCustomUserAgent } from "./customUserAgent";
import { getSession, getUuid, getUuidAndSession } from "./localStorage";

export interface IUser {
  avatar: any;
  email: string;
  firstName: string;
  id: number;
  login: string;
  phone: string;
  needToReload: boolean;
  loaded: boolean;
}
export interface IUserEmailChangeReq {
  email: string;
  code: string;
}
export interface IUserEmailChangeRes {
  email: string;
  needToReload: boolean;
  loaded: boolean;
}

export const $user = createStore({
  needToReload: true,
  firstName: "",
  email: "",
  phone: "",
  loaded: false,
  id: 0,
});
interface IUserUpdate{
  object:object
  user:IUser
}

export const queryUser = createEffect<void, IUser>();
export const queryUserUpdateName = createEffect<IUserUpdate, IUser>();
export const queryUserUpdatePhone = createEffect<IUserUpdate, IUser>();
export const queryEmailChange = createEffect<
  IUserEmailChangeReq,
  IUserEmailChangeRes
>();

$user.on(queryUser.doneData, (_, val) => val);
$user.on(queryUserUpdateName.doneData, (_, val) => val);
$user.on(queryEmailChange.doneData, (user, val) => {
  return { ...user, ...val };
});

queryUser.use(() =>
  fetch("https://izba.kras-abs.ru/api/v3/user/data", {
    method: "POST",
    body: JSON.stringify({
      uuid: getUuid(),
      session: getSession(),
    }),
    headers: {
      accept: "*/*",
      "Custom-User-Agent": getCustomUserAgent(),
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => res.json())
    .then((res) => {
      const user = {
        ...res,
        
        needToReload: false,
        loaded: true,
      };
      return user;
    })
    .catch((error) => {
      console.log("err:", error);
      const errUser = {
        avatar: "",
        email: "Не удалось загрузить email",
        firstName: "Не удалось загрузить имя",
        id: 666,
        login: "Не удалось загрузить логин",
        phone: "Не удалось загрузить телефон",
        needToReload: true,
        loaded: true,
      } as IUser;
      return errUser;
    })
);
queryUserUpdateName.use((params) =>
  fetch("https://izba.kras-abs.ru/api/v3/user/setName", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      ...params.object,
    }),
    headers: {
      accept: "*/*",
      "Custom-User-Agent": getCustomUserAgent(),
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.json();
      else throw new Error();
    })
    .then((res) => {
      const user = {//@ts-ignore
        firstName:params.object.name,
        avatar:params.user.avatar,
        email:params.user.email,
        id:params.user.id,
        login:params.user.login,
        phone:params.user.phone,
        needToReload: false,
        loaded: true,
      };
      return user;
    })
);
queryUserUpdatePhone.use((params) =>
  fetch("https://izba.kras-abs.ru/api/v3/user/updatePhone", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      ...params.object,
    }),
    headers: {
      accept: "*/*",
      "Custom-User-Agent": getCustomUserAgent(),
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.json();
      else throw new Error();
    })
    .then((res) => {
      const user = {//@ts-ignore
        login:params.object.login,//@ts-ignore
        phone:params.object.phone,
        avatar:params.user.avatar,
        email:params.user.email,
        id:params.user.id,
        firstName:params.user.firstName,
        needToReload: false,
        loaded: true,
      };
      return user;
    })
);

export function getSecretCode(email: string) {
  return fetch("https://izba.kras-abs.ru/api/v3/user/updateMail", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      mail: email,
    }),
    headers: {
      accept: "*/*",
      "Custom-User-Agent": getCustomUserAgent(),
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  }).then((res) => res.json());
}

queryEmailChange.use(({ email, code }) =>
  fetch("https://izba.kras-abs.ru/api/v3/user/updateMailConfirm", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      mail: email,
      code: code,
    }),
    headers: {
      accept: "*/*",
      "Custom-User-Agent": getCustomUserAgent(),
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.json();
      else throw new Error();
    })
    .then(() => {
      const user = {
        email: email,
        needToReload: false,
        loaded: true,
      };
      return user;
    })
);

export function addSlaveUser(accountId: number, phone: string) {
  return fetch("https://izba.kras-abs.ru/api/v3/user/setSlave", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      accountId: accountId,
      phone: phone,
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (res) return;
      else throw new Error("Не удалось добавить пользователя");
    });
}
